import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from "vue";
import { useIsPcView } from "@/hooks/use-is-pc";
import CardPC from "./card/pc/Card.vue";
import CardSp from "./card/sp/Card.vue";
import EmptyState from "./card/common/EmptyState.vue";
import Loading from "@/components/common/Loading.vue";
import CompanyInvoiceApi from "@/api/company-invoice";
import { ICompanyInvoice } from "@/models/company-invoice";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPcView = useIsPcView();

const isInitialLoading = ref(true);
const companyInvoices = ref<ICompanyInvoice[]>([]);

onMounted(async () => {
  await CompanyInvoiceApi.getCsCompanyInvoices().then((res) => {
    console.log(res);
    companyInvoices.value = res;
    isInitialLoading.value = false;
  });
});

const displayInvoice = computed(() => {
  console.log(companyInvoices.value);
  return companyInvoices.value[0];
});

const remainInvoices = computed(() => {
  return companyInvoices.value.slice(1);
});

return (_ctx: any,_cache: any) => {
  return (isInitialLoading.value)
    ? (_openBlock(), _createBlock(Loading, {
        key: 0,
        "is-loading": isInitialLoading.value,
        "is-fixed": ""
      }, null, 8, ["is-loading"]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (companyInvoices.value.length === 0)
          ? (_openBlock(), _createBlock(EmptyState, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(isPcView))
                ? (_openBlock(), _createBlock(CardPC, {
                    key: 0,
                    "company-invoice": displayInvoice.value,
                    "remain-company-invoices": remainInvoices.value
                  }, null, 8, ["company-invoice", "remain-company-invoices"]))
                : (_openBlock(), _createBlock(CardSp, {
                    key: 1,
                    "company-invoice": displayInvoice.value,
                    "remain-company-invoices": remainInvoices.value
                  }, null, 8, ["company-invoice", "remain-company-invoices"]))
            ], 64))
      ], 64))
}
}

})